var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8299 18.2329C12.9144 15.9496 12.8155 13.4203 13.5497 11.0724C14.2839 8.72456 15.8062 6.70221 17.8594 5.34721C19.9125 3.99221 22.3706 3.38766 24.818 3.63576C27.2654 3.88386 29.5521 4.96939 31.2916 6.70886C33.0311 8.44833 34.1166 10.735 34.3647 13.1825C34.6128 15.6299 34.0082 18.0879 32.6532 20.1411C31.2982 22.1943 29.2759 23.7166 26.928 24.4508C24.5801 25.185 22.0508 25.086 19.7675 24.1706L19.7676 24.1704L17.813 26.1249H14.2505V29.6874H10.688V33.2499H4.75049V27.3124L13.8301 18.2328L13.8299 18.2329Z",
    stroke: "#2555FE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.7188 11.875C27.0467 11.875 27.3125 11.6092 27.3125 11.2812C27.3125 10.9533 27.0467 10.6875 26.7188 10.6875C26.3908 10.6875 26.125 10.9533 26.125 11.2812C26.125 11.6092 26.3908 11.875 26.7188 11.875Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7188 12.7656C27.5385 12.7656 28.2031 12.101 28.2031 11.2812C28.2031 10.4615 27.5385 9.79688 26.7188 9.79688C25.899 9.79688 25.2344 10.4615 25.2344 11.2812C25.2344 12.101 25.899 12.7656 26.7188 12.7656Z",
    fill: "#2555FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.c0b52723.svg";
export { ForwardRef as ReactComponent };